export default __webpack_public_path__ + "static/media/sw-2.4559bd6f.svg";